import { Bridge } from '@nackle/bridge';
import { setOptions } from '@nackle/salesmaker-client-fetch';
import auth from 'app/auth';
import { SetUserDataAction } from 'app/dux/session/actionTypes';
import { AuthState } from 'app/dux/session/types';
import React, { Component, ReactNode } from 'react';
import { buildFetchDefaultsFromAuthState } from './fetchDefaults';
import { navigate } from '@reach/router';

interface Props {
    children: ReactNode;
    isAuthenticated: boolean;
    setUserData: (user: AuthState) => SetUserDataAction;
}

export class BridgeWrapper extends Component<Props> {
    resetOptions = async () => {
        const authState = (auth as any).state as AuthState;
        
        if (!authState.delegate.access_token) {
            return;
        }
        await setOptions({
            headers: {
                Authorization: `Bearer ${authState.delegate.access_token ||
                    authState.access_token}`,
                'company-id': authState.delegate.claims.company_id,
                'person-id': authState.delegate.claims.person_id
            }
        });
        await this.props.setUserData(authState);
        if (!window.location.pathname.includes('company')) {
            const match = window.location.pathname.match(
                /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
            );
            navigate(
                `/company/${(match && match[0]) ||
                    authState.delegate.claims.company_id ||
                    authState.claims.company_id}`
            );
        }
    };
    public render() {
        const {
            children,
            isAuthenticated,
        } = this.props;

        return (
            <Bridge
                auth={auth}
                onAuthStateChange={this.resetOptions}
                onSignIn={this.handleSignIn}
            >
                { isAuthenticated && children }
            </Bridge>
        );
    }

    private handleSignIn = async () => {
        const authState = (auth as any).state as AuthState;

        try {
            const fetchDefaults = buildFetchDefaultsFromAuthState(authState);
            await setOptions(fetchDefaults);

            await this.props.setUserData(authState);

            if (!window.location.pathname.includes('company')) {
                const match = window.location.pathname.match(
                    /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
                );
                navigate(
                    `/company/${(match && match[0]) ||
                        authState.delegate.claims.company_id ||
                        authState.claims.company_id}`
                );
            }

        } catch (e) {
            console.error(e);
        }
    };
}
